import type { Ability } from "../../rules";
import type { SpearheadArmy } from "./rules";

export const LightningStrikeArrival: Ability = { time: "ymp" };

export const ThePrimeHuntress: Ability = { time: "p" };
export const StrikeWithTheTempestRage: Ability = { time: "p" };
export const DazzlingRadiance: Ability = { oncePerBattle: true, time: "ymp" };
export const HawkOfTheCelestialStrike: Ability = { oncePerBattle: true, time: "afp" };

export const DriveThemBack: Ability = { time: "eat" };
export const DefendToTheLast: Ability = { time: "p" };

export const StormcastEternalsYndrastaSpearhead: SpearheadArmy = {
  battleTraits:      [LightningStrikeArrival],
  enhancements:      [ThePrimeHuntress],
  faction:           "se",
  regimentAbilities: [DriveThemBack, DefendToTheLast]
};
